import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class ApplicationRoute extends Route {
  @service auth;
  @service router;

  beforeModel(transition) {
    // Allow access to login route without authentication
    if (transition.to.name === 'login') {
      return;
    }

    // Check if user is authenticated
    if (!this.auth.isAuthenticated) {
      console.log('[Application] Not authenticated, redirecting to login');
      this.router.transitionTo('login');
    }
  }
}
